import memoize from 'lodash/memoize';

// Typography 스타일 설정
const TYPOGRAPHY_CONFIG = {
  HEAD: [28, 24, 22, 20],
  BODY: [18, 17, 16, 15, 14, 13],
  CAPTION: [12, 11, 10, 9],
} as const;

const WEIGHTS = ['BOLD', 'SEMIBOLD', 'MEDIUM', 'REGULAR'] as const;

// Typography 카테고리 타입 ex) HEAD, BODY, CAPTION
type Category = keyof typeof TYPOGRAPHY_CONFIG;
// Typography 사이즈 타입 ex) 28, 24, 22, 20
type Size<T extends Category> = (typeof TYPOGRAPHY_CONFIG)[T][number];
// Typography 굵기 타입 ex) BOLD, SEMIBOLD, MEDIUM, REGULAR
type Weight = (typeof WEIGHTS)[number];

type TypographyKey = {
  [C in Category]: {
    [S in Size<C>]: {
      [W in Weight]: `${C}_${S}_${W}` | `${C}_${S}_MULTILINE_${W}`;
    }[Weight];
  }[Size<C>];
}[Category];

// Typography 상수 생성 함수 (with 메모이제이션)
const generateTypography = memoize(() => {
  const result = {} as Record<TypographyKey, string>;

  (Object.entries(TYPOGRAPHY_CONFIG) as [Category, readonly number[]][]).forEach(([category, sizes]) => {
    sizes.forEach((size) => {
      WEIGHTS.forEach((weight) => {
        // 일반 버전: HEAD_28_BOLD
        const key = `${category}_${size}_${weight}` as TypographyKey;
        const value = `${category}_${size} ${weight}`;
        result[key] = value;

        // 멀티라인 버전: HEAD_28_MULTILINE_BOLD
        const multilineKey = `${category}_${size}_MULTILINE_${weight}` as TypographyKey;
        const multilineValue = `${category}_${size} MULTILINE ${weight}`;
        result[multilineKey] = multilineValue;
      });
    });
  });

  return result;
});

// Typography 상수
export const Typography = generateTypography();
